import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";

const getUserTimezone = () => 'UTC';

//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};
const showWarningMessage = (msg) => {
  enqueueSnackbar(`${msg}`, {
    variant: "warning",
    preventDuplicate: true,
  });
};

// Create Dashboard
export const createDashboard = async (data = {}) => {
  console.log(data)
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard2/create/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};

// Utilities Dashboard
export const utilitiesDashboard = async () => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(`${tenant}/api/dashboard/utilities/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "dashboard"));
  }
};

// Graphics Dashboard
export const getGraphicsDashboard = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  
  try {
    const resp = await apiCall.get(`${tenant}/api/dashboard/detail/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      params: data,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};


export const getGraphicsDashboardv2 = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  try {
    const resp = await apiCall.post(`${tenant}/api/dashboardv2/detail/`, { ...data, timezone: getUserTimezone() }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
  
};

// Graphics Dashboardv2
export const getGraphicsDashboard2 = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  
  try {
    const resp = await apiCall.get(`${tenant}/api/dashboard2/detail/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      params: data,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};

// Delete Dashboard using path
/**
 * data = {
 *  path: "path"
 * }
 */
export const deleteElement = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.delete(`${tenant}/api/dashboard/delete/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      data: data,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};
export const deleteElement2 = async (data) => {
  
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.delete(`${tenant}/api/dashboard/delete-graph/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      data: data,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};

// Get Data By Path
export const updateDataGraphicByPath = async (data, signal) => {

  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/element/`, { ...data, timezone: getUserTimezone() }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
      ...(signal && { signal }), // Soporte para AbortController
    });
    return {
      status: resp.status,
      data: resp.data.data,
    };
  } catch (error) {
    throw new Error(getErrorMessage(error, "dashboard"), { cause: error })
  }
};

// Get last Report from API
export const getLastReport = async () => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(`${tenant}/api/report/list/?limit=5`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};









export const getDefaultGraphics = async () => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(`${tenant}/api/dashboard/add/default-graphics/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showWarningMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};











// Modify the Dashboard default
export const modifyGraficsDefault = async (data = {}) => {
  const session = getSession();
  const tenant = getTenant();

  
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/modify/defaut/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};



// Modify the Dashboard default
export const addGraficsDefaultDashboard = async (data = {}) => {
  const session = getSession();
  const tenant = getTenant();  

  
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/add/defaut/dashboard/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};




// Modify the Dashboard default
export const createCopyOfDefault = async (data = {}) => {
  const session = getSession();
  const tenant = getTenant();  

  
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/create/copy/default/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};

// Get catalogue general
export const getCatalogue = async () => {
  const session = getSession();
  const tenant = getTenant();
  const data={
    "is_own": false,
    "catalogue": "",
    "path": "/"
    }
  try {
    const resp = await apiCall.get(`${tenant}/api/list/catalogues/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return {
      status: resp.status,
      data: resp.data,
    };
  } catch (error) {
    return {
      status: (error.response?.status || 'Error de red'),
      data: (error.response?.statusText || 'Error de red'),
    };
  }
};

// Get catalogo a detalle
export const getCataloguedetail = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  
  try {
    const resp = await apiCall.post(`${tenant}/api/detail/catalogue/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return {
      status: resp.status,
      data: resp.data,
    };
  } catch (error) {
    return {
      status: (error.response?.status || 'Error de red'),
      data: (error.response?.statusText || 'Error de red'),
    };
  }
};

export const oneColumnChange = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/change/column/`, data,{
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return {
      status: resp.status,
      data: resp.data.data,
    };  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};


export const modifyOrder = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/modify-order/`, data,{
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "dashboard")
    );
    console.error(error);
  }
};






// Get Data By Path INDICATOR
export const updateIndicatorsDates = async (data) => {
  
  const session = getSession();
  const tenant = getTenant();
  
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboard/indicators/dates/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return {
      status: resp.status,
      data: resp.data.data,
    };
  } catch (error) {
    return {
      status: (error.response?.status || 'Error de red'),
      data: (error.response?.statusText || 'Error de red'),
    };
  }
};



export const updateOrderAPI = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  
  try {
    const resp = await apiCall.post(`${tenant}/api/dashboardv2/move/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return {
      status: resp.status,
      data: resp.data.data,
    };
  } catch (error) {
    return {
      status: (error.response?.status || 'Error de red'),
      data: (error.response?.statusText || 'Error de red'),
    };
  }
};



